import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const RouteErrorFallback: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <h2 className="text-lg font-semibold">Something went wrong</h2>
      <p className="text-sm text-gray-500">
        An unexpected error occurred while loading this page.
      </p>
      <div className="flex gap-2">
        <Button onClick={() => navigate(-1)} variant="secondary">
          Go Back
        </Button>
        <Button onClick={() => window.location.reload()}>Reload Page</Button>
      </div>
    </div>
  );
};
